import { render, staticRenderFns } from "./newControlItem.vue?vue&type=template&id=2a676b3c&scoped=true"
import script from "./newControlItem.vue?vue&type=script&lang=js"
export * from "./newControlItem.vue?vue&type=script&lang=js"
import style0 from "./newControlItem.vue?vue&type=style&index=0&id=2a676b3c&scoped=true&lang=css"
import style1 from "./newControlItem.vue?vue&type=style&index=1&id=2a676b3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a676b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a676b3c')) {
      api.createRecord('2a676b3c', component.options)
    } else {
      api.reload('2a676b3c', component.options)
    }
    module.hot.accept("./newControlItem.vue?vue&type=template&id=2a676b3c&scoped=true", function () {
      api.rerender('2a676b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/components/newControlItem.vue"
export default component.exports